import { useQuery } from "@tanstack/react-query";
import { Modal, Table } from "antd";
import moment from "moment/moment";
import React, { useState } from "react";
import { LiaFileDownloadSolid } from "react-icons/lia";
import { API_CONSTANTS } from "../../../../api/Constants";
import AccessTo from "../../../../components/is-show/AccessTo";
import { SM } from "../../../router/AddRoutesJson";
import UploadDataForm from "./UploadDataForm";
import { IoTrashOutline } from "react-icons/io5";
import {
  currentRole,
  getUserByRole,
  userEmail,
} from "../../../../api/apiCallManager";

// Fetch data from the API
const fetchData = async () => {
  const response = await fetch(
    `${API_CONSTANTS.UPLOAD_BASE_URL}site?action=read_record&email=${userEmail}&userRole=${currentRole}`
  );
  if (!response.ok) {
    throw new Error("Failed to fetch data");
  }
  const result = await response.json();
  // Return the data array directly
  if (result.statusCode == 200) return result.body || [];
  else return [];
};

const DataListTable = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Use React Query to fetch data
  const { data, error, isLoading } = useQuery({
    queryKey: ["_filesList"],
    queryFn: fetchData,
  });

  const showModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Columns definition
  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
    },
    // {
    //   title: "S3 Path",
    //   dataIndex: "bucketPath", // Assuming this corresponds to the S3 path
    //   key: "bucketPath",
    //   render: (bucketPath) => (
    //     <a href={bucketPath}>
    //       <LiaFileDownloadSolid size={18} />
    //     </a>
    //   ),
    // },
    {
      title: "Project Name",
      dataIndex: "projectKey",
      key: "projectKey",
    },
    // {
    //   title: "Project Description",
    //   dataIndex: "projectDescription", // Assuming this field exists
    //   key: "projectDescription",
    // },
    {
      title: "Dataset Name",
      dataIndex: "dataSetName", // Assuming this field exists
      key: "dataSetName",
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    // },
    {
      title: "Site Name",
      dataIndex: "siteName", // Assuming this field exists
      key: "siteName",
    },
    {
      title: "Region",
      dataIndex: "region", // Assuming this field exists
      key: "region",
    },
    {
      title: "Timestamp",
      dataIndex: "uploadTime",
      key: "uploadTime",
      render: (time) => moment(time).format("MMMM DD, YYYY"),
    },
    // {
    //   title: "Action",
    //   dataIndex: "-",
    //   key: "ac",
    //   render: () => <IoTrashOutline color="red" size={"17"} />,
    // },
  ];

  return (
    <div className="crd-wrap">
      <Modal
        destroyOnClose={true}
        title=""
        open={isModalOpen}
        onCancel={closeModal}
        maskClosable={false}
        footer={null}
      >
        <UploadDataForm />
      </Modal>
      <div className="my-4"></div>
      {/* <AccessTo role={[SM]}>
        <div className="flex justify-end items-center mb-3">
          <button className="crt-usr-btn" onClick={showModal}>
            Upload +
          </button>
        </div>
      </AccessTo> */}
      <Table
        scroll={{ x: 600 }}
        dataSource={data}
        columns={columns}
        className="user-table-theme"
        rowKey="record_id" // Use unique identifier
      />
    </div>
  );
};

export default DataListTable;
